import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PageBanner } from '../components/PageBanner';
const categories = [{
  id: 'all',
  name: 'All'
}, {
  id: 'braids',
  name: 'Braids'
}, {
  id: 'locs',
  name: 'Locs'
}, {
  id: 'twisted',
  name: 'Twisted Hair Styles'
}, {
  id: 'protective',
  name: 'Protective Hair Styles'
}];
const galleryItems = [{
  id: 701,
  title: 'Precision Stitch Braids',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/2LQEJGbUsLv8PsUV311qUy/WhatsApp_Image_2026-03-27_at_7.57.48_PM.jpg'
}, {
  id: 702,
  title: 'Custom Cornrow Design',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/c2KHWEEhy76DeSC2C2WFG4/WhatsApp_Image_2026-03-27_at_7.53.57_PM.jpg'
}, {
  id: 703,
  title: 'Boho Knotless Transformation',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/qgyURBi3UQxNPSZeYEj1av/WhatsApp_Image_2026-03-27_at_7.53.20_PM.jpg'
}, {
  id: 704,
  title: 'Elegant Braided Style',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/jmMyybXqkZjfx7buNA7xvB/WhatsApp_Image_2026-03-27_at_7.53.20_PM_(1).jpg'
}, {
  id: 705,
  title: 'Masterful Braiding',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/ki2uu2v68wp2mVtZVhdZz3/Screenshot_2026-03-19_160128.png'
}, {
  id: 501,
  title: 'Signature Knotless',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/3kUPkGrZf1j7p79xt5GkLh/unnamed_(5).webp'
}, {
  id: 502,
  title: 'Goddess Transformation',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/ptdadMo8NPeQ6XnMdY69mH/unnamed_(4).webp'
}, {
  id: 503,
  title: 'Custom Cornrows',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/crCTSmWDU5nbKxFsRHbc9a/WhatsApp_Image_2026-03-27_at_7.53.57_PM.jpg'
}, {
  id: 101,
  title: 'Precision Braiding',
  category: 'braids',
  image: 'https://images.unsplash.com/photo-1617391654484-2894196c2cc9?auto=format&fit=crop&q=100&w=3840'
}, {
  id: 102,
  title: 'Boho Knotless Style',
  category: 'braids',
  image: 'https://images.unsplash.com/photo-1632765854612-9b02b6ec2b15?auto=format&fit=crop&q=100&w=3840'
}, {
  id: 103,
  title: 'Elegant Twisted Look',
  category: 'twisted',
  image: 'https://images.unsplash.com/photo-1589156280159-27698a70f29e?auto=format&fit=crop&q=100&w=3840'
}, {
  id: 104,
  title: 'Masterful Cornrows',
  category: 'braids',
  image: 'https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?auto=format&fit=crop&q=100&w=3840'
}, {
  id: 105,
  title: 'Signature Transformation',
  category: 'protective',
  image: 'https://images.unsplash.com/photo-1649922151405-833ae2ddf296?auto=format&fit=crop&q=100&w=3840'
}, {
  id: 601,
  title: 'Butterfly Locs',
  category: 'locs',
  image: 'https://cdn.magicpatterns.com/uploads/a3c659UdAMd6Hs4w5uXHHj/WhatsApp_Image_2026-03-27_at_7.53.45_PM.jpg'
}, {
  id: 602,
  title: 'Senegalese Twists',
  category: 'twisted',
  image: 'https://cdn.magicpatterns.com/uploads/9nRZkHQQaLf7wuD5XZhpAj/unnamed_(3).webp'
}, {
  id: 603,
  title: 'Passion Twists',
  category: 'twisted',
  image: 'https://cdn.magicpatterns.com/uploads/4iM6Ke2wpBnUu3H4grDgrK/unnamed.webp'
}, {
  id: 604,
  title: 'Crochet Braids',
  category: 'protective',
  image: 'https://cdn.magicpatterns.com/uploads/67HcVthnseTHXdQPLsyyDG/Screenshot_2026-03-19_160206.png'
}, {
  id: 605,
  title: 'Silk Press',
  category: 'protective',
  image: 'https://cdn.magicpatterns.com/uploads/sWzNLxxe1d3Tg3LRxjE2SP/Screenshot_2026-03-19_160143.png'
}];
export function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const filteredItems = activeCategory === 'all' ? galleryItems : galleryItems.filter(item => item.category === activeCategory);
  return <>
      <PageBanner title="Style Gallery" subtitle="A glimpse into the artistry and precision of our master braiders" backgroundImage="https://cdn.magicpatterns.com/uploads/eg5LzjxM23zTxgJaZWtdFS/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(3).jpg" data-id="element-513" />
      <section className="py-16 bg-white" data-id="element-514">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-515">
          <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-516">
            {categories.map(cat => <button key={cat.id} onClick={() => setActiveCategory(cat.id)} className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${activeCategory === cat.id ? 'bg-brand-gold text-white shadow-md' : 'bg-gray-100 text-jet hover:bg-brand-gold hover:text-white'}`} data-id="element-517">
                {cat.name}
              </button>)}
          </div>
          <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-518">
            <AnimatePresence mode="popLayout" data-id="element-519">
              {filteredItems.map((item, index) => <motion.div key={item.id} layout initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.3,
              delay: index * 0.03
            }} className="relative aspect-[4/5] rounded-2xl overflow-hidden group cursor-pointer" data-id="element-520">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-521" />
                  <div className="absolute inset-0 bg-gradient-to-t from-jet/80 via-jet/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-522"></div>
                  <div className="absolute inset-0 p-5 flex flex-col justify-end translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-523">
                    <div className="w-8 h-1 bg-golden mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-524"></div>
                    <h3 className="text-lg font-heading font-bold text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-150" data-id="element-525">
                      {item.title}
                    </h3>
                    <span className="text-golden/80 text-sm capitalize opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200" data-id="element-526">
                      {item.category === 'twisted' ? 'Twisted Hair Style' : item.category}
                    </span>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-16 text-center" data-id="element-527">
            <p className="text-jet/60 mb-4" data-id="element-528">
              See more of our work on social media
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-529">
              <a href="https://share.google/AnuTHKxIlASaF1Cna" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-gray-200 text-near-black font-medium rounded-full hover:bg-gray-50 transition-colors" data-id="element-530">
                <svg className="w-5 h-5" viewBox="0 0 24 24" data-id="element-531">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-532" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-533" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" data-id="element-534" />
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-535" />
                </svg>
                View on Google
              </a>
              <a href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#833AB4] via-[#E1306C] to-[#F77737] text-white font-medium rounded-full hover:opacity-90 transition-opacity" data-id="element-536">
                Follow on Instagram
              </a>
              <a href="https://web.facebook.com/people/Roziiepse-hair-Braiding/61584040603587/#" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-[#1877F2] text-white font-medium rounded-full hover:bg-[#1877F2]/90 transition-colors" data-id="element-537">
                Follow on Facebook
              </a>
              <a href="https://www.tiktok.com/@roziiepse1.11" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-jet text-white font-medium rounded-full hover:bg-jet/80 transition-colors" data-id="element-538">
                Follow on TikTok
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}